import * as yup from 'yup';

export const activacionInstallOtSchema = yup.object({
  // nodo: yup.string().required('El nodo es requerido'),
  // olt: yup.string().required('La OLT es requerida'),
  nap: yup.string().required('La NAP es Requerida'),
  distancia: yup.string().required('La distancia a la nap es requerida'),
  puerto: yup
    .string()
    .required('El puerto es requerido')
    .min(1, 'Puerto inválido'),
  // router: yup.string().required('El router es requerido'),
  estado_activacion: yup
    .string()
    .required('El estado de activación es requerido'),

  coordenadas: yup.string().required('Las coordenadas son requeridas'),

  // validations when actualizar_nodo_olt is true -----
  actualizar_nodo_olt: yup.boolean().required().default(false),

  // ipv4_actual: yup.string().when('actualizar_nodo_olt', {
  //   is: false,
  //   then: schema => schema.required('La IPv4 es requerida'),
  // }),

  // ipv6_actual: yup.string().when('actualizar_nodo_olt', {
  //   is: false,
  //   then: schema => schema.required('La IPv6 es requerida'),
  // }),
  // pppoe: yup.string().when('actualizar_nodo_olt', {
  //   is: false,
  //   then: schema => schema.required('El PPPOE es requerido'),
  // }),
  // pppassword: yup.string().when('actualizar_nodo_olt', {
  //   is: false,
  //   then: schema => schema.required('El PPPASSWORD es requerido'),
  // }),
});

export const activacionInstallOTChangePortSchema = yup.object({
  nodo: yup.string().required('El nodo es requerido'),
  olt: yup.string().required('La OLT es requerida'),
  nap: yup.string().required('La NAP es Requerida'),
  puerto: yup
    .number()
    .typeError('El puerto es requerido')
    .required('El puerto es requerido')
    .min(1, 'Puerto inválido'),
  distancia: yup.string().required('La distancia a la nap es requerida'),
  router: yup.string().required('El router es requerido'),
  estado_activacion: yup
    .string()
    .required('El estado de activación es requerido'),
});
